(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-home-news"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new WeakMap();
  const bind = slider => {
    if (!slider.matches?.('.ahn hdt-slider[data-ace-news-rotation]') || controllers.has(slider)) return;
    const events = new AbortController();
    const motion = matchMedia('(prefers-reduced-motion:reduce)');
    const hover = matchMedia('(hover:hover)');
    let visible = false;
    let dragging = false;
    let timer;
    const pauseReason = () => {
      if (!slider.isConnected || !visible) return 'offscreen';
      if (document.hidden) return 'hidden';
      if (dragging) return 'interaction';
      if (slider.matches(':focus-within')) return 'focus';
      if (hover.matches && slider.matches(':hover')) return 'hover';
      return '';
    };
    const schedule = () => {
      clearTimeout(timer);
      const reason = pauseReason();
      slider.dataset.aceNewsRotationState = reason || (motion.matches ? 'instant' : 'sliding');
      if (reason) return;
      timer = setTimeout(() => {
        if (pauseReason()) return schedule();
        const dots = [...slider.querySelectorAll('[hdt-slider-dots] button')];
        if (dots.length > 1 && typeof slider.goToIndex === 'function') {
          const current = dots.findIndex(dot => dot.classList.contains('hdt-slider__dot--selected'));
          slider.goToIndex((Math.max(current, 0) + 1) % dots.length, motion.matches);
        }
        schedule();
      }, 5000);
    };
    const on = (target, type, listener) => target.addEventListener(type, listener, { signal: events.signal });
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(entry => entry.isIntersecting);
      schedule();
    });
    observer.observe(slider);
    on(slider, 'pointerenter', schedule);
    on(slider, 'pointerleave', schedule);
    on(slider, 'focusin', schedule);
    on(slider, 'focusout', () => requestAnimationFrame(schedule));
    on(slider, 'pointerdown', () => { dragging = true; schedule(); });
    on(window, 'pointerup', () => { if (dragging) { dragging = false; schedule(); } });
    on(window, 'pointercancel', () => { if (dragging) { dragging = false; schedule(); } });
    on(slider, 'click', schedule);
    on(document, 'visibilitychange', schedule);
    on(motion, 'change', schedule);
    const section = slider.closest('.shopify-section');
    on(document, 'shopify:section:unload', event => {
      if (event.target !== section) return;
      clearTimeout(timer);
      observer.disconnect();
      events.abort();
      controllers.delete(slider);
    });
    controllers.set(slider, true);
    schedule();
  };
  document.querySelectorAll('.ahn hdt-slider[data-ace-news-rotation]').forEach(bind);
  document.addEventListener('init:slide', event => bind(event.target), true);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.ahn hdt-slider[data-ace-news-rotation]').forEach(bind);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
